import { Provider } from 'react-redux';
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { DatabaseSecurity } from './database-security';
import { createStore } from '@common/utils/redux';
import { profileSettingsEN } from './translations/en';
import { profileSettingsES } from './translations/es';
import { profileSettingsJA } from './translations/ja';
import { combineReducers } from 'redux';
import { initializeRootAndReturnRender, unmountReactNode } from '@common/utils/react';

export const initDatabaseSecurity = function (locale) {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
  
    syncTranslationWithStore(store);
  
    const translation = {
      en: profileSettingsEN,
      ja: profileSettingsJA,
      es: profileSettingsES,
    };
  
    if (!translation[locale]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
  
    const container = document.createElement('div');

    document.body.appendChild(container);

    const { root, render } = initializeRootAndReturnRender(
      container
    );
    const close = () => unmountReactNode(root);

    render(
      <Provider store={store}>
        <DatabaseSecurity close={close} />
      </Provider>,
    );
  } catch (err) {
    console.error(err);
  }
};
